import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ad7892f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "detail_container"
}
const _hoisted_2 = { class: "detail_base-info card-white-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail_header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "发票信息")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "hw_detail_table_container card-white-6"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Link-File")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Send-File")
const _hoisted_7 = { class: "hw_detail_table_container card-white-6" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { style: {"margin-right":"8px"} }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_WeEditableWarp = _resolveComponent("WeEditableWarp")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_we_table = _resolveComponent("we-table")!
  const _component_FlowTimeLine = _resolveComponent("FlowTimeLine")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_InvoicePdfDialog = _resolveComponent("InvoicePdfDialog")!
  const _component_page_detail_wrapper = _resolveComponent("page-detail-wrapper")!
  const _directive_loading = _resolveDirective("loading")!

  return (_ctx.showInvoice)
    ? _withDirectives((_openBlock(), _createBlock(_component_page_detail_wrapper, _mergeProps({
        key: 0,
        title: _ctx.invoice.name + (_ctx.invoice.is_deleted ? ' [DELETED]' : '')
      }, _ctx.$attrs, {
        collapsed: true,
        drop_down_menus: _ctx.get_drop_down_menus
      }), {
        default: _withCtx(() => [
          (_ctx.showInvoice)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _createVNode(_component_a_form, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, {
                        gutter: 20,
                        type: "flex",
                        style: {"flex-wrap":"wrap"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "对方主体",
                                name: "company_name"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.invoice.company_name,
                                    edit: false
                                  }, {
                                    text: _withCtx(() => [
                                      _createElementVNode("span", null, [
                                        _createVNode(_component_a_button, {
                                          type: "link",
                                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.jumpToCompany(_ctx.invoice.company_id))),
                                          style: {"white-space":"pre-wrap"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.invoice.company_name), 1)
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "我方主体",
                                name: "we_company_name"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.invoice.we_company_name
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "属性",
                                name: "rd_property"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.invoice.rd_property,
                                    edit: false
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "分类",
                                name: "rd_category"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.invoice.rd_category,
                                    edit: false
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (!_ctx.invoice.is_purchase && _ctx.invoice.is_china)
                            ? (_openBlock(), _createBlock(_component_a_col, {
                                key: 0,
                                span: 6
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, {
                                    label: "发票分类",
                                    name: "service_name"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: _ctx.invoice.service_name,
                                        edit: false
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "创建人",
                                name: "creator_name"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.invoice.creator_name
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_divider, { style: {"margin":"5px 0"} }),
                      _createVNode(_component_a_row, {
                        gutter: 20,
                        type: "flex",
                        style: {"flex-wrap":"wrap"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "税率",
                                name: "tax_rate"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.invoice.tax_rate + '%'
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "发票号",
                                name: "invoice_number"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.invoice.invoice_number
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "开票日期",
                                name: "date"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.formatTime(_ctx.invoice.date, 'YYYY-MM-DD'),
                                    edit: false
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "Due Date",
                                name: "date"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.formatTime(_ctx.invoice.due_date, 'YYYY-MM-DD'),
                                    edit: false
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_ctx.invoice.currency)
                            ? (_openBlock(), _createBlock(_component_a_col, {
                                key: 0,
                                span: 6
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, {
                                    label: "币种",
                                    name: "name"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: _ctx.invoice.currency.name
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_row, {
                        gutter: 20,
                        type: "flex",
                        style: {"flex-wrap":"wrap"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "含税金额",
                                name: "it_amount"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.formatMoneyByRound(_ctx.invoice.it_amount)
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "不含税金额",
                                name: "et_amount"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.formatMoneyByRound(_ctx.invoice.et_amount)
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "税额",
                                name: "tax_amount"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.formatMoneyByRound(_ctx.invoice.tax_amount)
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "关联金额",
                                name: "linked_amount"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.formatMoneyByRound(_ctx.invoice.linked_amount)
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (!_ctx.invoice.is_blank && !_ctx.invoice.is_china && !_ctx.isSupplyPage && !_ctx.isPurchasePage)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_a_divider, { style: {"margin":"5px 0"} }),
                            _createVNode(_component_a_row, {
                              gutter: 20,
                              type: "flex",
                              style: {"flex-wrap":"wrap"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "我方税号",
                                      name: "we_tax_number"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.invoice.we_tax_number,
                                          edit: false
                                        }, null, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                (_ctx.invoice.we_bank_id)
                                  ? (_openBlock(), _createBlock(_component_a_col, {
                                      key: 0,
                                      span: 6
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, {
                                          label: "我方银行",
                                          name: "bf_bank"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_WeEditableWarp, {
                                              value: _ctx.invoice.we_bank.bf_bank,
                                              edit: false
                                            }, null, 8, ["value"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.invoice.we_bank_id)
                                  ? (_openBlock(), _createBlock(_component_a_col, {
                                      key: 1,
                                      span: 6
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, {
                                          label: "银行账号",
                                          name: "bf_account_number"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_WeEditableWarp, {
                                              value: _ctx.invoice.we_bank.bf_account_number,
                                              edit: false
                                            }, null, 8, ["value"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (!_ctx.invoice.is_china && _ctx.invoice.we_bank_id)
                                  ? (_openBlock(), _createBlock(_component_a_col, {
                                      key: 2,
                                      span: 6
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, {
                                          label: "Webeye Swift Code",
                                          name: "bf_swift_code"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_WeEditableWarp, {
                                              value: _ctx.invoice.we_bank.bf_swift_code
                                            }, null, 8, ["value"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_a_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "我方联系方式",
                                      name: "we_phone"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.invoice.we_phone,
                                          edit: false
                                        }, null, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_col, { span: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "我方地址",
                                      name: "we_address"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.invoice.we_address,
                                          edit: false
                                        }, null, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_row, {
                              gutter: 20,
                              type: "flex",
                              style: {"flex-wrap":"wrap"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "对方税号",
                                      name: "cs_tax_number"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.invoice.cs_tax_number,
                                          edit: false
                                        }, null, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                (_ctx.invoice.cs_bank_id)
                                  ? (_openBlock(), _createBlock(_component_a_col, {
                                      key: 0,
                                      span: 6
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, {
                                          label: "对方银行",
                                          name: "bf_bank"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_WeEditableWarp, {
                                              value: _ctx.invoice.cs_bank.bf_bank,
                                              edit: false
                                            }, null, 8, ["value"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.invoice.cs_bank_id)
                                  ? (_openBlock(), _createBlock(_component_a_col, {
                                      key: 1,
                                      span: 6
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, {
                                          label: "银行账号",
                                          name: "bf_account_number"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_WeEditableWarp, {
                                              value: _ctx.invoice.cs_bank.bf_account_number,
                                              edit: false
                                            }, null, 8, ["value"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (!_ctx.invoice.is_china && _ctx.invoice.cs_bank_id)
                                  ? (_openBlock(), _createBlock(_component_a_col, {
                                      key: 2,
                                      span: 6
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, {
                                          label: "对方 Swift Code",
                                          name: "bf_swift_code"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_WeEditableWarp, {
                                              value: _ctx.invoice.cs_bank.bf_swift_code,
                                              edit: false
                                            }, null, 8, ["value"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_a_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "对方联系方式",
                                      name: "cs_phone"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.invoice.cs_phone,
                                          edit: false
                                        }, null, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_col, { span: 12 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "对方地址",
                                      name: "cs_address"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.invoice.cs_address,
                                          edit: false
                                        }, null, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.invoice.linked_bill_list)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_we_table, _mergeProps(_ctx.configLinkedBillList, {
                        "data-source": _ctx.invoice.linked_bill_list
                      }), {
                        name: _withCtx(({ text, record }) => [
                          (!record.is_purchase)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "link",
                                onClick: ($event: any) => (_ctx.jumpToBill(record))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(text), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : (_openBlock(), _createBlock(_component_a_button, {
                                key: 1,
                                type: "link",
                                onClick: ($event: any) => (_ctx.jumpToPay(record.pay))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(text) + "（虚拟账单）", 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                        ]),
                        rd_state_name: _withCtx(({ text, record }) => [
                          _createElementVNode("span", {
                            style: _normalizeStyle({ color: record.rd_state_color })
                          }, _toDisplayString(text), 5)
                        ]),
                        link: _withCtx(({ record }) => [
                          _withDirectives(_createVNode(_component_a_button, {
                            type: "link",
                            onClick: ($event: any) => (_ctx.linkBillFiles(record))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 2
                          }, 1032, ["onClick"]), [
                            [_vShow, _ctx.canLinkFile(record)]
                          ]),
                          _withDirectives(_createVNode(_component_a_button, {
                            type: "link",
                            onClick: ($event: any) => (_ctx.sendBillFiles(record))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 2
                          }, 1032, ["onClick"]), [
                            [_vShow, _ctx.canLinkFile(record)]
                          ])
                        ]),
                        _: 1
                      }, 16, ["data-source"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, [
                  (!_ctx.isEmptyData(_ctx.invoice.flow))
                    ? (_openBlock(), _createBlock(_component_FlowTimeLine, {
                        key: 0,
                        flow: _ctx.invoice.flow,
                        onOnCatchFlag: _ctx.catchFlowFlag,
                        onOnUpdate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getInvoiceDetail(Number(_ctx.invoiceId))))
                      }, null, 8, ["flow", "onOnCatchFlag"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_a_modal, {
            visible: _ctx.linkBillDialog,
            "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.linkBillDialog) = $event)),
            width: "1000px",
            centered: "",
            title: "关联账单"
          }, {
            footer: _withCtx(() => [
              _createElementVNode("span", _hoisted_9, "未关联金额: " + _toDisplayString(_ctx.formatMoneyByRound(_ctx.linkBillUnlinked)), 1),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.linkBillDialog = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.linkBillForInvoice
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            default: _withCtx(() => [
              (!_ctx.isEmptyData(_ctx.InvoiceBillList))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_a_form, { ref: "linkForm" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_table, {
                          dataSource: _ctx.InvoiceBillList,
                          columns: _ctx.InvoiceBillListColumns,
                          pagination: false,
                          rowKey: 
              (_record, index) => {
                return index;
              }
            ,
                          "row-selection": {
              selectedRowKeys: _ctx.BillSelectedRowKeys,
              onChange: _ctx.linkBillCheckAllChange,
              onSelect: _ctx.linkBillChange,
            }
                        }, {
                          linked_amount: _withCtx(({ record, index }) => [
                            _createVNode(_component_a_input, {
                              disabled: !record.is_checked,
                              value: _ctx.InvoiceBillList[index].linked_amount,
                              "onUpdate:value": ($event: any) => ((_ctx.InvoiceBillList[index].linked_amount) = $event),
                              onChange: ($event: any) => (_ctx.linkMoneyChanged(record))
                            }, {
                              suffix: _withCtx(() => [
                                _createVNode(_component_svg_icon, {
                                  "icon-name": "TagsOutlined",
                                  onClick: ($event: any) => (_ctx.autoLinkBill(record, index))
                                }, null, 8, ["onClick"])
                              ]),
                              _: 2
                            }, 1032, ["disabled", "value", "onUpdate:value", "onChange"])
                          ]),
                          _: 1
                        }, 8, ["dataSource", "columns", "rowKey", "row-selection"])
                      ]),
                      _: 1
                    }, 512)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["visible"]),
          _createVNode(_component_a_modal, {
            visible: _ctx.linkBillFilesDialog,
            "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.linkBillFilesDialog) = $event)),
            width: "1000px",
            centered: "",
            title: "Link Bill Files"
          }, {
            footer: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.linkBillFilesDialog = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.linkBillFilesForInvoice
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_a_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_table, {
                      dataSource: _ctx.linkFiles,
                      columns: _ctx.linkFilesColumns,
                      rowKey: 
              (_record, index) => {
                return index;
              }
            ,
                      pagination: false,
                      "row-selection": {
              selectedRowKeys: _ctx.BillFileSelectedRowKeys,
              onChange: _ctx.linkBillFilesCheckAllChange,
            }
                    }, null, 8, ["dataSource", "columns", "rowKey", "row-selection"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["visible"]),
          _createVNode(_component_InvoicePdfDialog, {
            invoice: _ctx.invoice,
            ref: "InvoicePdfDialog",
            showBuline: _ctx.showBuline,
            company_name: _ctx.companyName,
            neutralize_reason: _ctx.neutralizeInvoiceReason,
            logic_type: _ctx.logic_type,
            onAdd_pdf_done: _ctx.handle_save_pdf
          }, null, 8, ["invoice", "showBuline", "company_name", "neutralize_reason", "logic_type", "onAdd_pdf_done"])
        ]),
        _: 1
      }, 16, ["title", "drop_down_menus"])), [
        [_directive_loading, _ctx.invoiceDetailLoading]
      ])
    : _createCommentVNode("", true)
}